export function getOrdinalSuffix(day: number): string {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

export function calculateDaysRemaining(decisionedDate: string): number | null {
  const decision = new Date(decisionedDate);
  if (Number.isNaN(decision.getTime())) {
    return null;
  }
  const expiration = new Date(decision);
  expiration.setDate(expiration.getDate() + 30);
  return Math.ceil((expiration.getTime() - Date.now()) / 86_400_000);
}

export function formatExpirationDate(decisionedDate: string): string {
  const decision = new Date(decisionedDate);
  if (Number.isNaN(decision.getTime())) {
    return '';
  }
  const expiration = new Date(decision);
  expiration.setDate(expiration.getDate() + 30);
  const day = expiration.getDate();
  const month = expiration.toLocaleDateString('en-US', { month: 'long' });
  return `${month} ${day}${getOrdinalSuffix(day)}`;
}

export function formatCarCount(count: number): string {
  return count.toLocaleString('en-US');
}
